
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.75 10.5a4.853 4.853 0 01-2.5-.664A5.167 5.167 0 014.414 8a4.991 4.991 0 01-.664-2.5c0-.885.221-1.719.664-2.5A5.167 5.167 0 016.25 1.164 4.853 4.853 0 018.75.5c.911 0 1.745.221 2.5.664A5.167 5.167 0 0113.086 3c.443.781.664 1.615.664 2.5s-.221 1.719-.664 2.5a5.167 5.167 0 01-1.836 1.836 4.853 4.853 0 01-2.5.664zm-1.797 1.875h3.594c1.953.052 3.594.73 4.922 2.031 1.302 1.328 1.979 2.969 2.031 4.922 0 .339-.117.612-.352.82-.208.235-.481.352-.82.352H1.172c-.339 0-.612-.117-.82-.352-.235-.208-.352-.481-.352-.82.052-1.953.73-3.594 2.031-4.922C3.36 13.104 5 12.427 6.953 12.375z","fill":"#00DA5F"}})])
          )
        }
      }
    